module.exports = __webpack_public_path__ + "img/yishi6.06ff32bf.jpg";